var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__cursepreview mb-2"},[_c('div',{staticClass:"d-flex p-3 b-white rounded shadow-sm align-items-center"},[_c('i',{staticClass:"fas fa-briefcase font-blue mr-1"}),_vm._v(" "),_c('span',{staticClass:"font-blue font-weight-bold text-left"},[_vm._v(_vm._s(_vm.jobParent.titulo))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b890b84","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/#pages/jobs/components/JobNavBar.vue
// module id = null
// module chunks = 